require '../transforms/array-of-objects'
backgroundStyle = require 'utils/background-style-prop'

###
# Модель клиента
###
App.Client = DS.Model.extend
  name            : DS.attr 'string'
  avatar          : DS.attr 'string'
  comment         : DS.attr 'string'
  email           : DS.attr 'string'
  average_check   : DS.attr 'number'
  orders_count    : DS.attr 'number'
  is_blacklisted  : DS.attr 'boolean'
  blacklisted_comment : DS.attr 'string'
  # blacklisted_by  : DS.belongsTo 'ApiUser', async: true
  blacklisted_at  : DS.attr 'date'
  blacklisted_by_name  : DS.attr 'string'
  registered_at   : DS.attr 'date'
  last_order_at   : DS.attr 'date'
  first_order_at  : DS.attr 'date'
  birthdate       : DS.attr 'date'
  loona_card_id   : DS.attr 'number'
  social_accounts : DS.attr 'arrayOfObjects'

  total_orders_count:  DS.attr 'number'
  total_average_check: DS.attr 'number'

  created_at      : DS.attr 'date'

  phones          : DS.hasMany 'phone'
  addresses       : DS.hasMany 'client_address'
  client_tags     : DS.hasMany 'client_tag', async: true

  # Возвращаемость: new, active, returned, cold, dead
  recurrence      : DS.attr 'string'

  bonus           : DS.attr 'mixed'

  organization:  DS.belongsTo 'organization', async: true


  avatarFallback: (->
    return @get('avatar') if !Em.isEmpty(@get('avatar'))
    'images/account-placeholder@2x.png'
  ).property('')
  avatarBackground: backgroundStyle('avatarFallback')

  bonuses: (->
    v = @get('bonus.amount')
    return null unless v
    return 0 if parseInt(v) < 0
    parseInt v
  ).property('bonus')

App.Client.reopenClass

  FIXTURES: [
    id              : 1
    name            : 'Алексей Тактаров'
    phone           : '+7 (345) 234-45-23'
    avatar          : 'https://pp.vk.me/c625730/v625730839/ffbf/IhEcWoWWEyQ.jpg'
    comment         : 'Не любит, когда его называют котиком'
    is_blacklisted  : false
    registered_at   : '2015-04-16T00:37:55+03:00'
    last_order_at   : '2015-04-16T00:37:55+03:00'
    average_check   : 840
    orders_count    : 8
    tags            : [1, 2, 4, 5]
    recurrence      : 'new'
  ,
    id              : 2
    name            : 'Лиана Гукасян'
    phone           : '+7 (945) 234-45-23'
    avatar          : 'https://pp.vk.me/c625824/v625824286/feee/jwUbD-PAjn8.jpg'
    comment         : 'Слишком добрая, можно давать ей меньше сдачи'
    is_blacklisted  : true
    registered_at   : '2015-04-02T00:37:55+03:00'
    last_order_at   : '2015-04-02T00:37:55+03:00'
    average_check   : 2300
    orders_count    : 2
    tags            : [3]
    recurrence      : 'new'
  ,
    id              : 3
    name            : 'Ксения Швецова'
    phone           : '+7 (934) 234-45-23'
    avatar          : 'https://pp.vk.me/c624523/v624523765/2dcfd/gaesEHVbtt4.jpg'
    comment         : 'Любит, когда кладут больше сырного соуса'
    is_blacklisted  : false
    registered_at   : '2015-04-09T00:37:55+03:00'
    last_order_at   : '2015-04-09T00:37:55+03:00'
    average_check   : 1560
    orders_count    : 9
    recurrence      : 'cold'
  ,
    id              : 4
    name            : 'Виктор Суздалев'
    phone           : '+7 (324) 234-67-23'
    avatar          : 'https://pp.vk.me/c621721/v621721020/af82/HTvOo_q_OD4.jpg'
    comment         : 'Аллергия на сою'
    is_blacklisted  : false
    registered_at   : '2015-04-11T00:37:55+03:00'
    last_order_at   : '2015-04-11T00:37:55+03:00'
    average_check   : 780
    orders_count    : 1
    tags            : [3, 4, 5]
    recurrence      : 'new'
  ,
    id              : 5
    name            : 'Тихон Белоусько'
    phone           : '+7 (324) 234-67-23'
    avatar          : null
    comment         : 'Аллергия на яйца'
    is_blacklisted  : false
    registered_at   : '2015-04-12T00:37:55+03:00'
    last_order_at   : '2015-04-13T00:37:55+03:00'
    average_check   : 560
    orders_count    : 1
    recurrence      : 'dead'
  ]


# App.ClientAdapter = DS.FixtureAdapter
